import axios from 'axios'
import utils from './utils'

const apiServices = {
  getAll: function (url, isPrivate, startIndex = 1, itemPerPage = 5, searchValue = '', ID ) {
    let urlFinal = ''
    if (isPrivate) {
      let aux = ''
      if (ID) aux = `&id=${ID}`
      urlFinal = utils.getAPIURL(url, true).concat(`&start_index=${startIndex - 1}&item_per_page=${itemPerPage}&search_value=${searchValue}${aux}`)
    } else {
      urlFinal = utils.getAPIURL(url, false, ID)
    }

    return axios.get(urlFinal)
      .then(response => response.data
      )
      .catch(function (error) {
        if (!error.response || error.response.status === 403) {
          window.location.href = '/#/login'
        }
      })
  },
  getItem: function (url, isPrivate, id) {
    return axios.get(utils.getAPIURL(url, isPrivate, id))
      .then(response => response.data.length > 0 ? response.data[0] : window.location.href = `/#/404` // si existe devuelve el primero del array, de no existir redirecciona a la url
      )
      .catch(function (error) {      
        console.log(error)
        if(isPrivate)
          if (!error.response || error.response.status === 403) {
            window.location.href = '/#/login'
          }
      })
  },
  addItem: function (url, isPrivate = true, body) {
    return axios.post(utils.getAPIURL(url, isPrivate), body)
      .then(response => response
      )
      .catch(function (error) {
        if (!error.response || error.response.status === 403) {
          window.location.href = '/#/login'
        }
      })
  },
  updateItem: function (url, id, body) {
    return axios.patch(utils.getAPIURL(url, true, id), body)
      .then(response => response
      )
      .catch(function (error) {
        if (!error.response || error.response.status === 403) {
          window.location.href = '/#/login'
        }
      })
  },
  deleteItem: function (url, id) {
    return axios.delete(utils.getAPIURL(url, true, id))
      .then(response => response
      )
      .catch(function (error) {
        if (!error.response || error.response.status === 403) {
          window.location.href = '/#/login'
        }
      })
  },
  setStats: function (url, menuID) {
    const body = {
      MenuID: menuID,
      EnterpriseID: ''
    }
    return axios.post(utils.getAPIURL(url, false), body)
      .then(response => response
      )
      .catch(function (error) {
        if (!error.response || error.response.status === 403) {
          window.location.href = '/#/login'
        }
      })
  },
}

export default apiServices
